import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '../../types/monitoring';

interface AlertsPanelProps {
    alerts: Alert[];
}

const AlertsPanel: React.FC<AlertsPanelProps> = ({ alerts }) => {
    const navigate = useNavigate();

    const handleAlertClick = (containerId: string) => {
        const idParts = containerId.split('/');
        const resourceGroup = idParts[idParts.indexOf('resourceGroups') + 1];
        const appName = idParts[idParts.indexOf('containerapps') + 1];

        navigate(`/monitoring/apps/${resourceGroup}/${appName}`);
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
            <ul className="divide-y divide-gray-200 dark:divide-gray-700">
                {alerts.map((alert) => (
                    <li
                        key={alert.id}
                        onClick={() => handleAlertClick(alert.containerId)}
                        className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                    >
                        <div className="flex items-start">
                            <div className={`mt-1 flex-shrink-0 w-3 h-3 rounded-full ${alert.severity === 'critical' ? 'bg-red-500' :
                                    alert.severity === 'warning' ? 'bg-yellow-500' : 'bg-blue-500'
                                }`}></div>
                            <div className="ml-3 flex-1">
                                <p className="text-sm font-medium text-gray-900 dark:text-white">{alert.title}</p>
                                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{alert.message}</p>
                                <div className="mt-2 flex justify-between">
                                    <p className="text-xs text-gray-500 dark:text-gray-400">
                                        {new Date(alert.timestamp).toLocaleString()}
                                    </p>
                                    <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
                                        {alert.containerName}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AlertsPanel;